import { render, staticRenderFns } from "./typeList.vue?vue&type=template&id=08810b5a&"
import script from "./typeList.vue?vue&type=script&lang=js&"
export * from "./typeList.vue?vue&type=script&lang=js&"
import style0 from "./typeList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports